
import { Vue } from "vue-class-component";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { AwbDetail, AwbDetailData, AwbTracking } from "@/domain/entities/NGen";
import { gtmCargoData } from "@/app/ui/views/cargo/modules/gtm";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import {
  AirportData,
  AirportDataV2,
  CargoInputData
} from "@/domain/entities/Cargo";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AwbValidationApiRequest, CalculateVolumeApiRequest, CalculateVolumeRequest } from "@/data/payload/api/CargoApiRequest";
import {
  firstCapitalize,
  storeDatatoSessionStorage,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CALCULATE_TYPE, getConfigDimensionDivider, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece } from '../../modules/cargo-module';
import { FlagsPermissionCargo } from '@/feature-flags/flags-permission-cargo';

export default class CargoFlightManualSection extends Vue {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  unmounted() {
    this.fillFormBookingFromCache();
  }

  mounted() {
    this.onResetForm();
  }

  convertProduct(name: string) {
    return name;
  }
  setDateRange(date: Array<any>) {
    CargoController.setBookingDate(date);
  }
  onResetForm() {
    this.formBooking.isValidAwb = true;
    this.formBooking.isValidOriginOrDestination = true;
    this.formBooking.awbTracking = [];
    this.formBooking.ngenCreatedAt = "";
    this.formBooking.vehicleNumber = "";
    this.formBooking.cargoProduct = "";
    this.formBooking.nog = "";
  }

  get errorModalData() {
    return new ModalMessageEntities({
      image: "awb-not-found",
      textSuccess: this.$t("Isi Manual"),
      textCancel: this.$t("Cek Kembali"),
      onSubmit: () => {
        // GTM
        const gtmDetailViewInputManual = gtmCargoData({
          type: this.formBooking.cargoType
        }).detailViewInputManual;
        dataLayer(
          gtmDetailViewInputManual.eventName,
          gtmDetailViewInputManual.property,
          []
        );
        this.fillFormBookingFromCache();
        CargoController.setFillForm(true);
        MainAppController.closeMessageModal();
      },
      onClose: () => {
        CargoController.setFillForm(false);
        MainAppController.closeMessageModal();
      }
    });
  }
  showPopupFailedCheckAwb(awbDetailData: AwbDetailData) {
    CargoController.setFillForm(false);

    // update for isValidAwb or isValidOriginOrDestination
    this.onSaveAwbData(awbDetailData);

    const {
      isValidAwb,
      isValidOriginOrDestination,
      originAirportCode,
      destinationAirportCode
    } = awbDetailData.awbDetails;

    if (!isValidAwb) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          ...this.errorModalData,
          title: this.$t("Nomor Kargo Tidak Ditemukan"),
          message: this.$t(
            "Cek kembali nomor kargo Anda atau lakukan Booking Kargo secara manual"
          )
        })
      );
      return;
    }

    if (!isValidOriginOrDestination) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          ...this.errorModalData,
          customWidth: "417px",
          title: this.$t("Bandara asal dan tujuan tidak sesuai"),
          message: `
            <div class="flex flex-col items-center w-full gap-2">
              <div class="text-xs text-gray-lp-300 whitespace-nowrap">
                Cek kembali nomor kargo Anda atau booking kargo manual.
              </div>

              <div
                class="w-full border border-gray-lp-1600 flex flex-col items-center justify-center px-2.5 py-1.5 rounded-lg"
              >
                <div class="text-gray-lp-800 text-xs">
                  Rute penerbangan
                </div>

                <div class="font-semibold text-base text-gray-lp-300">${originAirportCode} - ${destinationAirportCode}</div>
              </div>
            </div>`
        })
      );
      return;
    }
  }
  formBookingCache = JSON.parse(JSON.stringify(this.formBooking));
  get formBooking() {
    return CargoController.form;
  }
  fillFormBookingFromCache() {
    if (!this.formBooking || !this.formBookingCache) {
      return;
    }
    this.formBooking.airportOrigin = this.formBookingCache?.airportOrigin;
    this.formBooking.airportDestination = this.formBookingCache.airportDestination;
    this.formBooking.cargoCommodityCode = this.formBookingCache.cargoCommodityCode;
    this.formBooking.cargoCommodityName = this.formBookingCache.cargoCommodityName;
    this.formBooking.cargoProduct = this.formBookingCache.cargoProduct;
    this.formBooking.vehicleNumber = this.formBookingCache.vehicleNumber;
    // this.formBooking.estTotalCargoGrossWeight = this.formBookingCache.estTotalCargoGrossWeight;
    // this.formBooking.actualTotalCargoGrossWeight = this.formBookingCache.actualTotalCargoGrossWeight;
    // this.formBooking.estTotalCargoVolumeWeight = this.formBookingCache.estTotalCargoVolumeWeight;
    // this.formBooking.actualTotalCargoVolumeWeight = this.formBookingCache.actualTotalCargoVolumeWeight;
  }
  get disabledInputAwb() {
    return this.isFillForm && this.formBooking.isValidOriginOrDestination;
  }
  get disabledCheckAwb() {
    return (
      !this.formBooking.cargoNumber ||
      (this.isFillForm && this.formBooking.isValidOriginOrDestination)
    );
  }
  onMappingAirport(data: AirportData[]): any[] {
    return data.map((airport: AirportData) => ({
      ...airport,
      name: `${airport.airportCode} - ${airport.airportName}`,
      value: airport.airportCode
    }));
  }
  get optionAirportOrigin() {
    return this.onMappingAirport(CargoController.airportDataOrigin.data);
  }
  get optionAirportDestination() {
    return this.onMappingAirport(CargoController.airportDataDestination.data);
  }
  // Extract tracking data processing
  private processTrackingData(awbTracking: AwbTracking[]) {
    const tracking = awbTracking.filter((e) =>
      ["Booking confirmed", "Booking executed"].includes(e.status)
    );

    const departureDate = new Date(
      `${tracking[0].flightDate} ${tracking[0].etd}`
    );
    const arrivalDate = new Date(
      `${tracking[tracking.length - 1].flightDate} ${
        tracking[tracking.length - 1].eta
      }`
    );

    this.setDateRange([departureDate, arrivalDate]);
    return tracking;
  }

  // Extract form booking update logic
  private updateFormBookingFromAwb(awbDetailData: AwbDetailData) {
    const {
      originCity,
      originCityName,
      destinationCity,
      destinationCityName,
      originAirportCode,
      originAirportName,
      destinationAirportCode,
      destinationAirportName,
      commodity,
      awbDate,
      product,
      awbNumber,
      grossWeight,
      volumeWeight
    } = awbDetailData.awbDetails;
    const awbTracking = awbDetailData.awbTracking;

    const commodityData = commodity.split("-");

    this.formBooking.ngenCreatedAt = awbDate;
    this.formBooking.originCityCode = originCity;
    this.formBooking.originCityName = originCityName;
    this.formBooking.destinationCityCode = destinationCity;
    this.formBooking.destinationCityName = destinationCityName;
    this.formBooking.airportOrigin = new AirportDataV2({
      airportCode: originAirportCode,
      airportName: originAirportName,
      cityCode: originCity,
      cityName: firstCapitalize(originCityName?.toLowerCase()),
      name: `${originAirportCode} - ${originAirportName}`,
      value: originAirportCode
    });
    this.formBooking.airportDestination = new AirportDataV2({
      airportCode: destinationAirportCode,
      airportName: destinationAirportName,
      cityCode: destinationCity,
      cityName: firstCapitalize(destinationCityName?.toLowerCase()),
      name: `${destinationAirportCode} - ${destinationAirportName}`,
      value: destinationAirportCode
    });
    this.formBooking.cargoCommodityCode = commodityData?.[0];
    this.formBooking.cargoCommodityName = commodityData?.[1];
    this.formBooking.cargoProduct = this.convertProduct(product);
    this.formBooking.cargoNumber = awbNumber;
    this.formBooking.vehicleNumber = awbTracking.length
      ? awbTracking[awbTracking.length - 1]?.flightNumber
      : "";
    this.formBooking.estTotalCargoGrossWeight = String(grossWeight);
    this.formBooking.actualTotalCargoGrossWeight = String(grossWeight);
    this.formBooking.estTotalCargoVolumeWeight = String(volumeWeight);
    this.formBooking.actualTotalCargoVolumeWeight = String(volumeWeight);
    this.calculateVolume(CALCULATE_TYPE.CHANGE_GW)
    this.onSaveAwbData(awbDetailData);

    // Reset specific fields
    this.formBooking.shcCode = "";
    this.formBooking.shcName = "";
  }
  onSaveAwbData(awbDetailData: AwbDetailData) {
    const { isValidAwb, isValidOriginOrDestination } = awbDetailData.awbDetails;
    const awbTracking = awbDetailData.awbTracking;
    const validOriginOrDestination = isValidAwb && isValidOriginOrDestination;

    this.formBooking.isValidAwb = isValidAwb;
    this.formBooking.isValidOriginOrDestination = validOriginOrDestination;
    this.formBooking.awbTracking = awbTracking;
    storeDatatoSessionStorage(
      "cargo-input-data",
      new CargoInputData({
        ...CargoController.cargoInputForm,
        isValidAwb,
        isValidOriginOrDestination,
        awbTracking
      })
    );

    // also update to cache for auto fill
    this.formBookingCache.isValidAwb = isValidAwb;
    this.formBookingCache.isValidOriginOrDestination = validOriginOrDestination;
    this.formBookingCache.awbTracking = awbTracking;
  }

  // Simplified onCheckAwb method
  async onCheckAwb() {
    MainAppController.showLoading();
    CargoController.setIsAwbValid(false);
    this.onResetForm();

    try {
      const res = await CargoController.getAwbValidation(
        new AwbValidationApiRequest({
          awbNumber: this.formBooking.cargoNumber,
          originCityCode: LocationController.districtDetail.cityCode,
          destinationCityCode: this.formBooking.destinationCityCode
        })
      );

      const { isValidAwb, isValidOriginOrDestination } = res.awbDetails;
      if (!isValidAwb || !isValidOriginOrDestination) {
        this.showPopupFailedCheckAwb(res);
        return;
      }

      // GTM Awb Valid
      const gtmAwbValid = gtmCargoData({ type: this.formBooking.cargoType })
        .awbValid;
      dataLayer(gtmAwbValid.eventName, gtmAwbValid.property, []);

      this.updateFormBookingFromAwb(
        new AwbDetailData({
          ...res,
          awbTracking: this.processTrackingData(res.awbTracking)
        })
      );

      // GTM
      const gtmDetailViewNgen = gtmCargoData({
        type: this.formBooking.cargoType
      }).detailViewNgen;
      dataLayer(gtmDetailViewNgen.eventName, gtmDetailViewNgen.property, []);

      CargoController.setFillForm(true);
      CargoController.setIsAwbValid(true);
    } catch (err) {
      // GTM Awb Invalid
      const gtmAwbInvalid = gtmCargoData({ type: this.formBooking.cargoType })
        .awbInvalid;
      dataLayer(gtmAwbInvalid.eventName, gtmAwbInvalid.property, []);
      this.showPopupFailedCheckAwb(
        new AwbDetailData({
          awbDetails: new AwbDetail({
            isValidAwb: false
          })
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  get errorMessageAwbDetail(): string {
    if (!this.formBooking.isValidAwb) {
      return `*${this.$t(
        "Pastikan nomor cargo telah sesuai, kesalahan pada nomor cargo akan menjadi tanggung jawab konsolidator terkait"
      )}`;
    }

    if (!this.formBooking.isValidOriginOrDestination) {
      return "Nomor kargo tidak valid karena kota bandara asal dan tujuan tidak sesuai.";
    }

    return "";
  }

  updateFormBookingCargoNumber(newValue: string) {
    // CargoController.setFillForm(false);
    // this.onResetForm();
    CargoController.setUpdateFromBookingCargoNumber(newValue);
  }

  get isFillForm() {
    return CargoController.isFillForm;
  }
  get isValidAwb() {
    const { isValidAwb, isValidOriginOrDestination } = this.formBooking;
    return isValidAwb && isValidOriginOrDestination;
  }

  parseNumber(value: string) {
    if (typeof value === "number") return value;
    return parseByCountry(value, { country: this.countryCode });
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(this.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  async calculateVolume(calculateType = ""){
    await this.$nextTick();
    CargoController.calculateVolume(new CalculateVolumeApiRequest({
      calculateType,
      calculateRequest: new CalculateVolumeRequest({
        cargoType: this.formBooking.cargoType,
        chargeableWeightReweigh: this.chargeableWeight,
        currentGrossWeight: this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
        height: this.formBooking.actualDimension.height,
        length: this.formBooking.actualDimension.length,
        width: this.formBooking.actualDimension.width,
        totalPieces: this.formBooking.actualTotalSTTPieces,
        volumeWeightReweigh: this.parseNumber(this.totalNewCalculationVolumeWeights as any),
        divider: getConfigDimensionDivider(this.formBooking.cargoType),
        isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus),
        minVolumePerPiece: getConfigMinimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus)
      })
    }))
  }
}
